import { Megaphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Button } from '@/components/shadcn/button';
import { CLICKUP_FEEDBACK_FORMS } from '@/constants/clickup';
import useClickUpForm from '@/hooks/useClickUpForm';

export default function FeedbackButton() {
  const { t } = useTranslation();

  const url = useClickUpForm(CLICKUP_FEEDBACK_FORMS);

  return (
    <Button variant="secondary" asChild>
      <Link to={url} target="_blank">
        <Megaphone />

        {t('FEEDBACK_BUTTON_LABEL')}
      </Link>
    </Button>
  );
}
